import { render, staticRenderFns } from "./Forgot_password.vue?vue&type=template&id=61b393c0&scoped=true"
import script from "./Forgot_password.vue?vue&type=script&lang=js"
export * from "./Forgot_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b393c0",
  null
  
)

export default component.exports